import { connect } from 'react-redux'
import BarComponent from '../components/BarComponent'
import { showModal } from 'redux/modules/modals'
import {
  addConso,
  selectCurrentTransaction,
  addProductsToTransaction,
  transfertTransaction,
  prepareForPayment,
  changeReducConso,
  addPayment,
  removePayment,
  removeConso,
  closeTransaction
} from 'redux/modules/transaction'
const mapActionCreators = {
  selectCurrentTransaction,
  changeReducConso,
  transfertTransaction,
  addPayment,
  closeTransaction,
  removePayment,
  addProductsToTransaction,
  addConso,
  removeConso,
  prepareForPayment,
  showModal
}

const mapStateToProps = state => {
  return {
    products: state.products.list,
    categories: state.categories.list,
    transaction: state.transactions.currentTransaction
  }
}

export default connect(mapStateToProps, mapActionCreators)(BarComponent)



// WEBPACK FOOTER //
// ./src/routes/Bar/containers/BarContainer.js